const EARTH_RADIUS_MILES = 3958.8

const toRad = deg => (deg * Math.PI) / 180
const toDeg = rad => (rad * 180) / Math.PI

// Returns a GeoJSON ring (array of [lng, lat] pairs) approximating a circle of
// `radiusMiles` around `center`, sampled at `points` evenly-spaced bearings.
// The ring is left open (first point not repeated) — persistGeofence closes it.
export const circleToRing = (center, radiusMiles, points = 64) => {
  const lat1 = toRad(center.lat)
  const lng1 = toRad(center.lng)
  const angularDistance = radiusMiles / EARTH_RADIUS_MILES

  const ring = []
  for (let i = 0; i < points; i++) {
    const bearing = toRad((i / points) * 360)
    const lat2 = Math.asin(
      Math.sin(lat1) * Math.cos(angularDistance) +
        Math.cos(lat1) * Math.sin(angularDistance) * Math.cos(bearing),
    )
    const lng2 =
      lng1 +
      Math.atan2(
        Math.sin(bearing) * Math.sin(angularDistance) * Math.cos(lat1),
        Math.cos(angularDistance) - Math.sin(lat1) * Math.sin(lat2),
      )
    ring.push([toDeg(lng2), toDeg(lat2)])
  }
  return ring
}
